import { call, put, takeLatest } from 'redux-saga/effects';
import { message as andMessage } from 'antd';
import {
  getCurrentHeroBanner,
  invalidateCacheHeroBanner,
  putCurrentHeroBanner,
  postHeroBanner,
} from '../../services/heroBanner';
import {
  REQUEST_HERO_BANNER,
  REQUEST_HERO_BANNER_FAIL,
  REQUEST_HERO_BANNER_SUCCESS,
  UPDATE_HERO_BANNER,
  UPDATE_HERO_BANNER_FAIL,
  UPDATE_HERO_BANNER_SUCCESS,
  CREATE_HERO_BANNER,
  CREATE_HERO_BANNER_SUCCESS,
  CREATE_HERO_BANNER_FAIL,
} from '../actionTypes';

function* fetchCurrentHeroBanner(action) {
  try {
    const data = yield call(getCurrentHeroBanner);
    yield put({ type: REQUEST_HERO_BANNER_SUCCESS, payload: { data } });
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: REQUEST_HERO_BANNER_FAIL, payload: message });
  }
}

function* updateCurrentHeroBanner({ payload: { id, data } }) {
  try {
    const newData = yield call(putCurrentHeroBanner, id, data);
    yield put({ type: UPDATE_HERO_BANNER_SUCCESS, payload: { id, data: newData } });
    // history.replace('/hero-banner'); // Redirect to hero banner list
    andMessage.success('Hero Banner was updated satisfactorily');
    yield call(invalidateCacheHeroBanner);
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: UPDATE_HERO_BANNER_FAIL, payload: message });
  }
}

function* createHeroBanner({ payload: data }) {
  try {
    const createdData = yield call(postHeroBanner, data);
    yield put({ type: CREATE_HERO_BANNER_SUCCESS, payload: createdData });
    andMessage.success('Hero Banner was created satisfactorily');
    yield call(invalidateCacheHeroBanner);
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: CREATE_HERO_BANNER_FAIL, payload: message });
  }
}

function* heroBannerSaga() {
  yield takeLatest(REQUEST_HERO_BANNER, fetchCurrentHeroBanner);
  yield takeLatest(UPDATE_HERO_BANNER, updateCurrentHeroBanner);
  yield takeLatest(CREATE_HERO_BANNER, createHeroBanner);
}

export default heroBannerSaga;
